import styled from '@emotion/styled'
import { Dialog } from '@mui/material'
import React from 'react'

import {
  ImageGalleryContextProvider,
  useImageGalleryContext
} from '@f-fertighaus/applications/Next/components/common/ImageGallery/ImageGalleryContext'
import { ImageGalleryFocusView } from '@f-fertighaus/applications/Next/components/common/ImageGallery/ImageGalleryFocusView'
import { ImagesGalleryImage } from '@f-fertighaus/applications/Next/components/common/ImageGallery/ImageGalleryImage'
import { ImageGalleryImageBox } from '@f-fertighaus/applications/Next/components/common/ImageGallery/ImageGalleryImageBox'
import { ImageGalleryImagesContainer } from '@f-fertighaus/applications/Next/components/common/ImageGallery/ImageGalleryImagesContainer'
import { transientOptions } from '@f-fertighaus/applications/Next/utils/transientOptions'

import {
  GALLERY_NAVBAR_HEIGHT,
  GALLERY_NAVBAR_HEIGHT_WITH_TABS,
  ImageGalleryNavigation
} from './ImageGalleryNavigation'

interface Props {
  open: boolean
  children: React.ReactNode
}

export const ImageGallery = (props: Props) => {
  const {
    state: { focusView }
  } = useImageGalleryContext()
  return (
    <ImageGalleryDialog
      fullScreen
      open={props.open}
      disableEnforceFocus
      data-sel='mdl-gallery'
      $hasTabs={!focusView.open}>
      {props.children}
    </ImageGalleryDialog>
  )
}

const ImageGalleryDialog = styled(Dialog, transientOptions)<{
  $hasTabs?: boolean
}>`
  // z-index of current funnel dialog is 1200. We trigger funnel dialog inside this dialog.
  z-index: 1100;

  & .MuiPaper-root {
    padding-top: ${({ $hasTabs }) =>
      $hasTabs ? GALLERY_NAVBAR_HEIGHT_WITH_TABS : GALLERY_NAVBAR_HEIGHT};
    background: ${({ theme }) => theme.palette.glass[100]};

    ${({ theme }) => theme.breakpoints.up('sm')} {
      padding-left: 5vw;
      padding-right: 5vw;
    }
  }
`

ImageGallery.Navigation = ImageGalleryNavigation
ImageGallery.FocusView = ImageGalleryFocusView
ImageGallery.ImageBox = ImageGalleryImageBox
ImageGallery.ImagesContainer = ImageGalleryImagesContainer
ImageGallery.Image = ImagesGalleryImage
ImageGallery.ContextProvider = ImageGalleryContextProvider
